const debtor = {
	discounts: {
		title: "Kortingen",
	},

	/* ----------------------------- DOMAIN SETTINGS ---------------------------- */
	domain_settings: {
		description: `Dit zijn alles of niets instellingen. Dus de ene naam niet en andere domeinnaam wel, gaat niet.
			Klant heeft eigen nameservers? Dan kunnen zij niet hun DNS beheren in Portal.
			Klant wil onze nameservers gebruiken met een eigen naam?
			
			Breng een engineer op de hoogte dat je dat gaat doen en laat de namen weten (bijv. n1.klantnaam.nl en ns2.klantnaam.nl. Klantnaam.nl moet bij ons staan!)
			Maak in OXXA een nameserver-groep aan met die namen
			Wacht op akkoord van de engineer.
			Voeg daarna die nameserver-groep in Portal toe en koppel die aan de debiteur

			Stel je niets in, dan worden standaard de nameservers van Tuxis gebruikt wat de gewenste instelling is. 
			Wijzig je deze instelling tussendoor, dan gaat die gelden voor alle nieuwe registraties. Oude registraties worden niet aangepast. 
			Je kan bij OXXA dus ook een nameserver-groep verwijderen.`,
		nameserver_group: {
			title: "Custom nameserver-groep",
		},
		title: "Domein instellingen",
	},
	information: {
		description: "",
		title: "Debiteur Informatie",
	},
	notes: {
		description: "Hier bevinden zich interne notities die de debiteur niet kan zien.",
		messages: {
			success: "Interne notitie succesvol bijgewerkt!",
		},
		title: "Notities debiteur",
	},
	products: {
		dadup: "Dadup",
		domain: "Domeinnamen",
		pbs: "Tuxis PBS",
		vps: "VPS'en",
	},

	/* ------------------------------ SETTINGS PAGE ----------------------------- */
	settings: {
		block_debtor: {
			block_button: "Debiteur blokkeren",
			blocked: "Geblokkeerd",
			deblock_button: "Debiteur deblokkeren",
			description: "",
			title: "Debiteur blokkeren/deblokkeren",
		},
		block_dialog: "Weet u zeker dat u debiteur <strong>{{debtor_code}}</strong> wilt blokkeren?",
		description: "",
		messages: {
			success: "Instelling gewijzigd!",
		},
		never_invoice: {
			description: "Deze debiteur nooit factureren",
			label: "Nooit facturen",
		},
		paid_services_disabled: {
			description: "Betaalde diensten uitsluiten",
			label: "Betaalde diensten",
		},
		status: {
			successful_block: "Debiteur succesvol geblokkeerd",
			successful_unblock: "Debiteur succesvol gedeblokkeerd",
		},
		title: "Debiteur instellingen",
		unblock_dialog:
			"Weet u zeker dat u debiteur <strong>{{debtor_code}}</strong> wilt deblokkeren?",
		vies: {
			button: "VIES-log bekijken",
			description: "",
			title: "VIES-API resultaten",
		},
	},
	status: {
		create: "Debiteur is succesvol toegevoegd!",
		update: "Debiteur is succesvol gewijzigd!",
	},
	tabs: {
		audit_log: "Audit log",
		discounts: "Kortingen",
		information: "Informatie",
		invoices: "Facturen",
		notes: "Notities",
		orders: "Orders",
		passwords: "Gedeelde wachtwoorden",
		products: "Producten",
		relations: "Relaties",
		settings: "Instellingen",
		users: "Gebruikers",
	},
	title: "Debiteur",
};

export default debtor;
